//let baseUrl = 'http://localhost/ppdb-yii/api/web/index.php/';
let baseUrl = 'https://rest.ppdb.arrisalah.sch.id/';
//let baseUrl = 'https://dev.rest.ppdb.arrisalah.sch.id/';


let config = {
  ar : {
    name    : 'Ar-Risalah',
    apps    : 'admin',   
    url     :  baseUrl, 
    rest    :  baseUrl + 'v01/',
    file    :  baseUrl + 'v01/site/',       
    console : true,    
    title   : 'AR-RISALAH',
    prefix  : 'ar',
    color   : 'green darken-4',
    cp : {
      label:'0821-6981-5584',      
      wa: '6282169815584',
      name:'Admin'      
    },
    cpk : {
      label:'+62 838-9635-6757',      
      wa: '6283896356757',
      name:'Admin Keuangan'
    },
    tahun:'2023/2024',
    group_wa:'https://chat.whatsapp.com/Ed2YI0yubIq9Lpxo7BBgf9',
    group_wa_smp1:'https://chat.whatsapp.com/Ff5xYN4A1ME1E12e0dtjXK',
    group_wa_smp2:'https://chat.whatsapp.com/Jdmt9FnfgHzGHtV9Cnc1MW'
    //color   : 'blue-grey',
  },  
} 
export default config['ar'];
